<script>
// Custom Components
import PageHeader from "@/components/page-header";
import hkService from "@/helpers/APIService/hk.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

// task sheet list

export default {
  page: {
    title: "Payment Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
  },
  computed: {
    ...authComputed,
  },
  data() {
    return {
      title: "Task Sheet",
      table: {
        tableData: [],
      },
      isLoading: false,
    };
  },
  mounted() {
    this.getTaskSheetList();
  },
  methods: {
    newSheet() {
      this.$router.push({ path: `/create-new-task` });
    },
    getTaskSheetList() {
      this.isLoading = true;
      hkService
        .getTaskSheetList()
        .then((response) => {
          this.table.tableData = response;
          this.isLoading = false;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    viewTaskSheet(id) {
      this.$router.push({ path: `/view-task-sheet/${id}` });
    },
    TaskSheetCompleted(id) {
      hkService
        .updateTaskSheetData(id, { status: "completed" })
        .then((response) => {
          if (response) {
            Middleware.notification("Marked as completed !!", "success");
            this.getTaskSheetList();
          }
        });
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      text="New Task Sheet"
      :action="newSheet"
      :isButton="true"
    />
    <div class="card">
      <div class="card-body">
        <!-- Table -->
        <div class="table-responsive mb-0">
          <table
            class="table table-hover mb-0"
            ref="my-table"
            v-infinite-scroll="getTaskSheetList"
            infinite-scroll-disabled="busy"
            infinite-scroll-distance="10"
          >
            <thead class="table-light">
              <tr>
                <th>ID</th>
                <th>Date</th>
                <th>Title</th>
                <th>Sequence</th>
                <th>status</th>
                <th>Created by</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody v-if="isLoading">
              <tr v-for="(item, index) in 20" :key="index">
                <td class="placeholder-glow" v-for="no in 7" :key="no">
                  <span class="placeholder w-100 placeholder-lg"></span>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr
                v-for="(data, index) in table.tableData"
                :key="index"
                class="text-capitalize"
              >
                <td @click="viewTaskSheet(data.id)">{{ data.sheet_id }}</td>
                <td @click="viewTaskSheet(data.id)">
                  {{ global_format_date(data.sheet_date) }}
                </td>
                <td @click="viewTaskSheet(data.id)">{{ data.title }}</td>
                <td @click="viewTaskSheet(data.id)">{{ data.sequence }}</td>
                <td @click="viewTaskSheet(data.id)">
                  <div
                    class="badge card-badge"
                    :class="
                      data.status == 'completed'
                        ? 'badge-soft-success'
                        : 'badge-soft-danger'
                    "
                  >
                    {{ data.status }}
                  </div>
                </td>
                <td @click="viewTaskSheet(data.id)">{{ data.created_by }}</td>
                <td>
                  <div class="d-flex align-items-center">
                    <i
                      class="fas fa-eye ms-2"
                      v-b-popover.hover="'view single task sheet'"
                      @click="viewTaskSheet(data.id)"
                    ></i>
                    <button
                      class="btn border-0 text-start"
                      :disabled="data.status == 'completed'"
                      @click="TaskSheetCompleted(data.id)"
                    >
                      <i
                        class="far fa-check-circle ms-3"
                        :class="
                          data.status == 'completed' ? 'text-success' : ''
                        "
                        v-b-popover.hover="'Mark as completed'"
                      ></i>
                    </button>
                    <!-- :style="
                      data.contract_signature !== null
                        ? 'color:#34c38f'
                        : 'color:#bbbfc4'
                    " -->
                  </div>
                </td>
              </tr>
            </tbody>

            <tbody v-if="!isLoading && table.tableData.length == 0">
              <tr>
                <td colspan="9" class="text-center">
                  <img
                    src="@/assets/images/empty.svg"
                    class="img-fluid"
                    alt=""
                  />
                  <p>
                    <span class="text-secondary">No Data Found</span>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
